import { fetchWithRetry } from '../utils/fetchHelper';

/**
 * Procesa una devolución (total o parcial)
 * @param {Object} config - Configuración de la devolución
 * @returns {Promise<Object>} Resultado de la operación
 */
export const processRefund = async (config) => {
    const { 
        accessToken, 
        userToken, 
        saleId, 
        refundAmount 
    } = config;
    
    const apiUrl = process.env.REACT_APP_API_URL_DEV; // Usando el endpoint de dev según el código original
    const url = `${apiUrl}/refund`;

    if (!saleId) throw new Error('MISSING_SALE_ID');

    try {
        const payload = { saleId: String(saleId) };
        if (refundAmount) {
            payload.refundAmount = Number(refundAmount);
        }

        const response = await fetchWithRetry(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': accessToken,
                'X-BP-AUTH': userToken,
            },
            body: JSON.stringify(payload),
        });

        const result = await response.json();

        return {
            status: response.status,
            data: result,
            isApproved: result?.message?.statusInfo === "APROBADA"
        };

    } catch (error) {
        console.error('Refund Service Error:', error);
        return { error: 'SERVICE_ERROR', message: error.message };
    }
};
